import Sanity from './config';

import { Product, Settings } from './types';

const image = `{
  'type': _type,
  'id': asset->_id,
  'src': asset->url,
  'aspectRatio': asset->metadata.dimensions.aspectRatio,
  'dimensions': { 
    'height': asset->metadata.dimensions.height, 
    'width': asset->metadata.dimensions.width
  },
  alt,
  'tabletImage': tabletImage[0]{
    'type': _type,
    'id': asset->_id,
    'src': asset->url,
    'aspectRatio': asset->metadata.dimensions.aspectRatio,
    'dimensions': { 
      'height': asset->metadata.dimensions.height, 
      'width': asset->metadata.dimensions.width
    },
    crop,
    hotspot,
  },
  'laptopImage': laptopImage[0]{
    'type': _type,
    'id': asset->_id,
    'src': asset->url,
    'aspectRatio': asset->metadata.dimensions.aspectRatio,
    'dimensions': { 
      'height': asset->metadata.dimensions.height, 
      'width': asset->metadata.dimensions.width
    },
    crop,
    hotspot,
  },
  'desktopImage': desktopImage[0]{
    'type': _type,
    'id': asset->_id,
    'src': asset->url,
    'aspectRatio': asset->metadata.dimensions.aspectRatio,
    'dimensions': { 
      'height': asset->metadata.dimensions.height, 
      'width': asset->metadata.dimensions.width
    },
    crop,
    hotspot,
  },
  crop,
  hotspot,
}`;

const relatedProduct = `{
  'code': product->code,
  'discountPercentage': product -> discountPercentage
}`;

const product = `{
  title,
  id,
  slug,
  code,
  isPreorder,
  'joinWaitlistOptions': {
    'showJoinWaitlist': joinWaitlistOptions.showJoinWaitlist,
    'eventSource': joinWaitlistOptions.eventSource,
    'submitSuccessMessage': joinWaitlistOptions.submitSuccessMessage,
    'ctaLabel': joinWaitlistOptions.ctaLabel,
  },
  'tags': tags[],
  'heroImage': heroImage[]${image},
  'thumbnailImage': thumbnailImage[0]${image},
  description,
  details[] {
    'key': _key,
    title,
    description,
  },
  ctaSubtext,
  listPrice,
  textPriceLine1,
  textPriceLine2,
  shortTextPrice,
  heroUpsellTitle,
  heroUpsellDescription,
  heroUpsellTitleWithoutPrice,
  bundleDiscountPercentage,
  'bundleItems': bundleItems[]${relatedProduct},
  'upSellProducts': upSellProducts[],
  'crossSellProducts': crossSellProducts[],
  reviews {
    rate,
    totalReviewerCount,
  },
  upsellDescription
}`;

const button = `{
  label,
  link,
  ariaLabel,
  id,
  'buttonColor': buttonColor.title,
}`;

const LinkGroup = `{
  'key': _key,
  'type': _type,
  linkGroupTitle,
  'linkGroupItems': linkGroupItems[]${button}
}`;

const settings = `*[_type == 'settings'][0]{
  'id': _id,
  'type': _type,
  'backgroundColor': backgroundColor.title,
  'textColor': textColor.title,
  'socialMedia': {
    'instagram': socialMedia.instagram,
    'linkedIn': socialMedia.linkedIn,
    'twitter': socialMedia.twitter,
    'youtube': socialMedia.youtube,
    'facebook': socialMedia.facebook,
    'tiktok': socialMedia.tiktok,
  },
  'footerSections': footerSections[]${LinkGroup},
  'footerCTA': {
    'ctaTitle': footerCTA.ctaTitle,
    'ctaDescription': footerCTA.ctaDescription,
    'ctaButton':  footerCTA.ctaButton${button},
  },
  legalCopy,
  'legalLinks': legalLinks[]${button},
  footerBarTitle,
  footerBarCta,
  'featureFlags': featureFlags[] {
    'name': name,
    'isEnabled': isEnabled,
    'description': description,
    'activationDate': activationDate,
  },
}`;

const handleSanityResponse = (parser: any) => (response: unknown) => {
  try {
    return parser.parse(response);
  } catch (err) {
    if (process.env.BUILD_ENV === 'development') {
      console.error('Sanity error:\n', err);
    } else {
      console.error('Production: Sanity error:\n', err);
    }

    return response;
  }
};

export const CmsClient: {
  fetchAllProducts(): Promise<Product[]>;
  fetchSettings(): Promise<Settings>;
} = {
  fetchAllProducts() {
    return Sanity.fetch(`*[_type == 'product'] ${product}`).then((res) => {
      return res as Product[];
    });
  },
  fetchSettings() {
    return Sanity.fetch(settings).then((res) => {
      return res;
    });
  },
};
